<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section">
    <div>
      <header class="shared-section-header">
        <h2 class="shared-section-header-heading">
          <router-link :to="{ name: 'training' }">
            {{ $t('preTraining.heading') }}
          </router-link>
        </h2>
        <span class="mx-4">
          <VSvgIcon name="chevron-double-right" />
        </span>
        <span class="font-bold">{{ product.display_name }}</span>
      </header>
      <PretrainingVisionWarning
        v-show="showWarningVision()"
        @handleVisionWarning="handleVisionWarning"
      />
      <PretrainingLesson v-show="showPreTraining" />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { safeNullDataset } from '@/utils/safeNullDataset';
import { isVision } from '@/utils';

import VSvgIcon from '@/components/base/VSvgIcon';
import VLoader from '@/components/base/VLoader';
import PretrainingLesson from '@/components/customer/PretrainingLesson';
import PretrainingVisionWarning from '@/components/customer/PretrainingVisionWarning';

export default {
  name: 'PretrainingLessons',
  components: {
    PretrainingLesson,
    PretrainingVisionWarning,
    VSvgIcon,
    VLoader,
  },
  data() {
    return {
      loading: false,
      showPreTraining: true,
    };
  },
  computed: mapState({
    product: state => state.customer.product ?? {},
    language: state => state.language ?? {},
  }),
  watch: {
    $language() {
      this.getProduct();
    },
  },
  methods: {
    async getProduct() {
      this.loading = true;
      // set product
      const product = await this.$store.dispatch('customer/getProduct', {
        productId: this.$route.params.id,
        lang_code: this.$language.code,
        includeVideos: true,
      });
      const videos = safeNullDataset(product)(['pretraining', 'data']);
      this.$store.commit('customer/setVideos', { videos });
      this.loading = false;
    },
    handleWarning() {
      localStorage.setItem('hasReadWarning', true);
      this.showPreTraining = true;
    },
    handleVisionWarning() {
      localStorage.setItem('hasReadVisionWarning', true);
      this.showPreTraining = true;
    },
    showWarningMultiHead() {
      if (this.product && this.product.is_multi_head) {
        if (!localStorage.getItem('hasReadWarning')) {
          this.showPreTraining = false;
          return true;
        }
        this.showPreTraining = true;
      }
      return false;
    },
    showWarningVision() {
      if (this.product && isVision(this.product.display_name)) {
        if (!localStorage.getItem('hasReadVisionWarning')) {
          this.showPreTraining = false;
          return true;
        }
        this.showPreTraining = true;
      }
      return false;
    },
  },
  created() {},
  mounted() {},
};
</script>
